import GenericTableResponse from "@/models/api/GenericTableResponse";
import OrderItemsListItem from "@/models/api/orders/OrderItemsListItem";

export default {
  items: [
    {
      id: "f5c557bd-c7b8-4840-9341-841602d9a50f",
      parentOrderItemId: null,
      name: "Bilet lotniczy krajowy ",
      ordinal: 1,
      purchaseNetPrice: 2.0,
      purchaseNetPriceInCurrency: 2.0,
      gross: 8.64,
      grossInCurrency: 1.9,
      ownerId: 0,
      currency: "EUR",
      purchaseNetPriceCurrency: "PLN",
      purchaseNetPriceExchangeRate: 1.0,
      profit: 6.0,
      profitCurrency: "PLN",
      purchaseNetPriceExchangeDate: "2021-01-15T00:00:00",
      orderItems: [
        {
          id: "41cca770-1d51-4041-8823-5a1d3770962a",
          parentOrderItemId: "f5c557bd-c7b8-4840-9341-841602d9a50f",
          name: "Bilet lotniczy krajowy",
          ordinal: 1,
          purchaseNetPrice: 2.0,
          purchaseNetPriceInCurrency: 2.0,
          gross: 5.4,
          grossInCurrency: 1.19,
          ownerId: 0,
          currency: "EUR",
          purchaseNetPriceCurrency: "PLN",
          purchaseNetPriceExchangeRate: 1.0,
          profit: 3.0,
          profitCurrency: "PLN",
          purchaseNetPriceExchangeDate: "2021-01-15T00:00:00",
        },
        {
          id: "f13dd914-34ec-4f8a-a932-fc1a3880d6e3",
          parentOrderItemId: "f5c557bd-c7b8-4840-9341-841602d9a50f",
          name: "Opłata za bilet lotniczy krajowy",
          ordinal: 2,
          purchaseNetPrice: 0.0,
          purchaseNetPriceInCurrency: 0.0,
          gross: 3.24,
          grossInCurrency: 0.71,
          ownerId: 0,
          currency: "EUR",
          purchaseNetPriceCurrency: "PLN",
          purchaseNetPriceExchangeRate: 1.0,
          profit: 3.0,
          profitCurrency: "PLN",
          purchaseNetPriceExchangeDate: "2021-01-15T00:00:00",
        },
      ],
    },
  ],
  totalCount: 2,
} as GenericTableResponse<OrderItemsListItem>;
